// utils/formatTime.js
export const formatTimeToAMPM = (timeString) => {
  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(+hours);
  date.setMinutes(+minutes);
  
  return date.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
